<template>
	<div class="margin-left">
		<div class="topall">
			<div class="bg-white padding-sm radius top">
				<div class="text-32 text-000 text-bold text-left">{{title}}</div>
				<div class="flex justify-between align-center">
					<div class="margin-top-sm">
						<div class="flex align-center justify-between" v-if="user">
							<p class="flex align-center">
								<img :src="user.avatar" class="block-30">
								<span class="text-sm text-333 margin-left-xs">{{user.nick_name}}</span>
							</p>
							<div class="flex align-center margin-left-xs">
								<img v-if="user.is_real == 2" class="" src="https://manage.ciiply.com/web/static/home/authentication.png"  style="width: 16px;height: 20px;" >
								<img v-if="user.is_real_company == 2" class="" src="https://manage.ciiply.com/web/static/home/enterprise.png"  style="width: 16px;height: 20px;" >
								<img v-else class="" src="https://manage.ciiply.com/web/static/home/random.png"  style="width: 16px;height: 20px;" >
								<p class="text-sm text-theme margin-left-xs" >{{user.is_real_company == 2?'企业已认证':user.is_real == 2?'个人已认证':'未认证'}}</p>
							</div>
						</div>
						<div class="flex align-center justify-between margin-top-xs">
							<!-- <p>
								<i class="el-icon-location-outline"></i>
								<span class="text-sm text-666">{{area}}</span>
							</p> -->
							<p>
								<span class="text-sm text-999">月租费用</span>
								<span class="text-prices">￥{{price}}/月</span>
							</p>
						</div>
					</div>
					<div class="flex align-center" v-if="status != 1">
						<div class="colt flex align-center justify-center pointer">
							<p class="margin-left-xs text-666">删除</p>
						</div>
						<div class="callbtns flex align-center justify-center margin-left-xs pointer">
							<p class="text-white margin-left-xs">修改信息</p>
						</div>
					</div>
				</div>
				<p v-if="status == 1" class="btn btn2">审核中</p>
				<p v-if="status == 2" class="btn btn3">未通过</p>
				<p v-if="status == 3" class="btn btn1">已发布</p>
			</div>
			<div class="failed flex align-center padding-tb-sm padding-lr-sm margin-top" v-if="status == 2">
				<p class="text-bold text-prices text-lg">未通过原因</p>
				<p class="reason margin-left-sm text-lg">{{reason}}</p>
			</div>
			<div class="bg-white margin-top padding-sm radius">
				<p class="title text-left padding-left-sm">产品详情</p>
				<div class="flex align-center margin-top-xs">
					<p class="tip text-sm text-666 margin-right-xs">{{cate_name}}</p>
					
				</div>
				<div class="text-666 text-sm margin-top">
					{{content}}
				</div>
			</div>
			<!-- <div class="bg-white margin-top padding-sm radius">
				<p class="title text-left padding-left-sm">企业介绍</p>
				
			</div>
			<div class="bg-white margin-top padding-sm radius">
				<p class="title text-left padding-left-sm">交易位置</p>
				<div class="txMap margin-top-sm">
				   <div id="allmap"></div>
				 </div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		components: {
		},
		name: '',
		data() {
			return {
				dataorigin: '',
				pointList: [],
				id:0,//
				title:'',//标题
				content:'',//内容
				cate_name:'',//分类
				status:'',//状态
				reason:'',//被拒原因
				user:null,
				area:'',
				price:''
			}
		},
		created() {
			Bus.$on('adid',data=>{
				console.log('-----',data);
				this.id = data
				this.getdetail()
			})
		},
		destroyed() {
			console.log('-----');
			Bus.$off('adid')
		},
		mounted () {
		    // this.initMap2()
		},
		methods: {
			back(){
				this.$router.back()
			},
			getdetail(){
				this.ajax('get', '/api/pc/hire/getInfo', {
					id:this.id,
				}, res => {
					if(res.status == 200){
						this.title = res.data.data.title
						this.content = res.data.data.content
						this.cate_name = res.data.data.cate_name
						this.status = res.data.data.status
						this.reason = res.data.data.reason
						this.user = res.data.data.user
						this.price = res.data.data.price
						
						console.log(this.title);
						this.$forceUpdate()
					}else{
						this.$message(res.msg);
					}
				})
			},
			//初始化地图
			initMap2 () {
			     // console.log("window", window);
			     // // 定义地图中心点坐标
			     // let center = new TMap.LatLng(39.906632, 116.413306);// 坐标靠近中间
			     // // 定义map变量，调用 TMap.Map() 构造函数创建地图
			     // var map = new TMap.Map(document.getElementById("allmap"), {
			     //   center: center,
			     //   zoom: 15
			     // });
			     // //   //初始marker
			     // var marker = new TMap.MultiMarker({
			     //   id: 'marker-layer',
			     //   map: map,
			     //   styles: {
			     //     // mark样式
			     //     "marker": new TMap.MarkerStyle({
			     //       "width": 25,
			     //       "height": 38,
			     //       "anchor": { x: 12, y: 32 },
			     //     })
			     //   },
			     //   geometries: [{
			     //     "id": 'demo1',
			     //     "styleId": 'marker',
			     //     "position": new TMap.LatLng(39.906632, 116.413306),
			     //     "properties": {
			     //       "title": "北京市东城区台基厂头条3号(王府井地铁站C3西南口步行470米)",
			     //       "address": "",
			     //     }
			     //   }]
			     // });
			     // //初始化infoWindow
			     // var infoWindow = new TMap.InfoWindow({
			     //   map: map,
			     //   position: new TMap.LatLng(39.906632, 116.413306),
			     //   offset: { x: 0, y: -32 }, //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
			     // });
			     // // infoWindow.close();//初始关闭信息窗关闭
							 //  console.log(marker);
							 //  let add = marker.geometries[0]
							 //  infoWindow.open(); //打开信息窗
							 //  infoWindow.setPosition(add.position);//设置信息窗位置
							 //  infoWindow.setContent(`<div style="white-space:
							 //    nowrap;margin:10px;color:#000;text-align:left;"> 
							 //    <p style="font-size:16px;">${add.properties.title}</p>
							 //     </div>`);//设置信息窗内容
			     // //监听标注点击事件
			     // marker.on("click", function (evt) {
			     //   console.log(evt)
			     //   //设置infoWindow
			     //   infoWindow.open(); //打开信息窗
			     //   infoWindow.setPosition(evt.geometry.position);//设置信息窗位置
			     //   infoWindow.setContent(`<div style="white-space:
			     //     nowrap;margin:10px;color:#000;text-align:left;"> 
			     //     <p style="font-size:16px;">${evt.geometry.properties.title}</p>
			     //      </div>`);//设置信息窗内容
			     // })
			   },
		}
	}
</script>

<style scoped lang="less">
	.topall{
		width: 921px;
		
	}
	//状态按钮
	.top{
		position: relative;
		.btn{
			position: absolute;
			top: 0;
			right: 0;
			width: 63px;
			height: 29px;
			line-height: 29px;
			border-radius: 0px 20px 0px 10px;
		}
		.btn1{
			background: rgba(11, 131, 124, 0.1);
			color: #0B837C;
		}
		.btn2{
			background: #FEF5E9;
			color: #FAA74F;
		}
		.btn3{
			background: #EAF0FC;
			color: #568EEB;
		}
	}
	//状态按钮 end
	.text-32{
		font-size: 32px;
	}
	//未通过原因 start
	.failed{
		background: #F4DFE0;
		border-radius: 20px;
		
	}
	//未通过原因 end
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
	.block-30{
		width: 30px;
		height: 30px;
		border-radius: 50%;
	}
	.colt{
		width: 111px;
		height: 45px;
		background: #FFFFFF;
		border: 1px solid #E6E6E6;
		border-radius: 23px;
	}
	.tip{
		padding: 12px 28px;
		background: #FFFFFF;
		box-shadow: 0px 5px 29px 2px rgba(204,204,204,0.3000);
		border-radius: 20px;
	}
	.callbtns{
		width: 193px;
		height: 45px;
		background: #0B837C;
		border-radius: 23px;
		.call-icon{
			width: 19px;
			height: 19px;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/components/my/lease/detail.vue